import {callApi} from '@/api/apibase'

export const getPaymentLink = function (locationId, orderIdentifier, origin, customersCourseToExtendId) {
    let endpoint = `/api/external/greencourse/GetPaymentLink?orderIdentifier=${orderIdentifier}&origin=${origin}`
    
    if (locationId != null) {
        endpoint = `/api/external/greencourse/GetPaymentLink?locationId=${locationId}&orderIdentifier=${orderIdentifier}&origin=${origin}`
    } 
    if (customersCourseToExtendId != null) {
        endpoint = endpoint + `&customersCourseToExtendId=${customersCourseToExtendId}`
    }

    return callApi(
        'GET', endpoint
    )
}
